// removed by extract-text-webpack-plugin
module.exports = {"phoneBlock":"_2PyXWbU8SGV5qvM9iHcuxi","phoneMask":"_2z6MI0C8hlXnCJ_YSf-ixa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorUser/HeaderPhones/HeaderPhones.scss
// module id = 1770
// module chunks = 0